module.exports = __webpack_public_path__ + "components/flag/static/square/ae-e11cfc47866f0c1ab8fe94a679788f2a.svg";